import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import plus from "../../../Components/assets/icons/a1.png";
import colunms from "../../../Components/assets/icons/LINES.png";
import pen from "../../../Components/assets/icons/pen.png";
import basket from "../../../Components/assets/icons/basket.png";
import search1 from "../../../Components/assets/icons/search.png";
import top from "../../../Components/assets/icons/top.png";
import Table from "react-bootstrap/Table";
import circle from "../../assets/icons/circle.png";
import rigth from "../../assets/icons/rigth.png";
import save from "../../assets/icons/save.png";
import cancel from "../../assets/icons/cross.png";
import { Link, useNavigate, useParams } from "react-router-dom";
import Header from "../../Header/Header";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import Button from "react-bootstrap/Button";
import Offcanvas from "react-bootstrap/Offcanvas";
// *******************toster****************************
import toast, { Toaster } from "react-hot-toast";
import { Button } from "react-bootstrap";
import { formatDate } from "../../../utils/common";
import Pagination from "react-bootstrap/Pagination";
import Pagination_Holder from "../../common/Pagination_Holder/Pagination_Holder";
import { post } from "jquery";
import { DeletButton } from "../../common/Button";
import { postData } from "../../../utils/api";
import Rating_Modal from "../../common/Rating_Modal/Rating_Modal";
library.add(fas);

const Tables = () => {
  const {
    getData,
    editStatusData,
    deleteData,
    ErrorNotify,
    getDownloadDataExcel,
    Per_Page_Dropdown,
  } = useContext(Context);
  const [modalShow, setModalShow] = useState(false);
  const [userId, setUserID] = useState("");
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setperPage] = useState(5);
  const [search, setSearch] = useState("");
  const [reset, setReset] = useState();
  const [show, setShowAdd] = useState(false);
  const [show1, setShowEdit] = useState(0);
  const [changeStatus, setChangeStatus] = useState();
  const [option, setOption] = useState();

  const [onPageChange, setonPageChange] = useState(1);

  const [totalPages, settotalPages] = useState();

  const handlePageChange = (pageNumber) => {
    setonPageChange(pageNumber);
  };

  const paginationItems = [];
  for (let page = 1; page <= totalPages; page++) {
    paginationItems.push(
      <Pagination.Item
        key={page}
        active={page === onPageChange}
        onClick={() => handlePageChange(page)}>
        {page}
      </Pagination.Item>,
    );
  }

  const getDataAll = async () => {
    const response = await getData(
      `/experts?page=${onPageChange}&per_page=${perPage}&term=${search}`,
    );
    await setData(response);
    setCurrentPage(response?.data?.currentPage);
    setperPage(response?.data?.per_page);
    setSearch(response?.data?.search_name);
    settotalPages(response?.data?.totalPages);
    // setCurrentPage(response?.data?.);
    setOption(await Per_Page_Dropdown(response?.data?.totalEntries));
    const newData = response?.data?.data;
    if (newData) {
      const newIds = newData.map((d) => d?.id);
      setAllChecked(newIds);
    }
  };

  useEffect(() => {
    getDataAll();
  }, [
    changeStatus,
    perPage,
    reset,
    show,
    show1,
    // search,
    onPageChange,
  ]);

  // const ChangeStatus = async (id) => {
  //   const response = await editStatusData(`/experts/${id}`);
  //   setChangeStatus(response);
  // };

  const ChangeStatus = async (id, status) => {
    const response = await editStatusData(`/experts/${id}`, {
      status: status,
    });

    if (response?.success) {
      getDataAll(); // refresh table
    }
  };

  const ChangeTopExpertStatus = async (id, status) => {
    const response = await editStatusData(`/experts/top-expert/${id}`, {
      top_status: status,
    });

    if (response?.success) {
      getDataAll(); // refresh table
    }
  };

  // Modal function
  const handleClose = () => setShowAdd(false);
  const handleShow = () => setShowAdd(true);

  const handleClose1 = () => setShowEdit(0);
  const handleShow1 = (id) => {
    setShowEdit(id);
  };

  // Select All Functionality
  const [selectAllChecked, setSelectAllChecked] = useState([]);
  const [allChecked, setAllChecked] = useState([]);

  const handleSelectAll = async () => {
    await setSelectAllChecked(allChecked);
  };

  const handleChange = async (e) => {
    const { value, checked } = e.target;

    if (value === "selectAll") {
      if (checked) {
        handleSelectAll();
      } else {
        await setSelectAllChecked([]);
      }
    } else {
      if (checked) {
        await setSelectAllChecked([...selectAllChecked, Number(value)]);
      } else {
        await setSelectAllChecked(
          selectAllChecked.filter((e) => e !== Number(value)),
        );
      }
    }
  };

  // Delete module
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [recordToDeleteId, setRecordToDeleteId] = useState(null);
  const [recordToDeleteName, setRecordToDeleteName] = useState(null);

  const showDeleteRecord = async (id, name) => {
    setShowDeleteModal(true);
    setRecordToDeleteId(id);
    setRecordToDeleteName(name);
  };

  const handleDeleteRecord = async () => {
    setShowDeleteModal(false);
    if (recordToDeleteId) {
      const response = await deleteData(`/experts/${recordToDeleteId}`);
      // notify("error", "Deleted Succefully");

      ErrorNotify(recordToDeleteName);

      setRecordToDeleteId(null);
      setRecordToDeleteName(null);
      setChangeStatus(response);
    }
  };

  const handleDeleteCancel = () => {
    setShowDeleteModal(false);
    setRecordToDeleteId(null);
    setRecordToDeleteName(null);
  };

  //  column hide and show.....
  const [visible, setVisibel] = useState({
    col0: true,
    col1: true,
    col2: true,
    col3: true,
    col4: true,
    col5: true,
    col6: true,
    col7: true,
    col8: true,
    col9: true,
    col10: true,
    col11: true,
    col12: true,
    col13: true,
    col14: true,
  });

  //toggle columnns.........
  const toggleColumn = (event, columnName) => {
    event.preventDefault();
    setVisibel((prev) => ({
      ...prev,
      [columnName]: !prev[columnName],
    }));
  };

  const HandleDownload = async () => {
    if (selectAllChecked.length == 0) {
      alert("Please Select Atleast One Record");
    } else {
      try {
        await getDownloadDataExcel(
          "/experts/download",
          selectAllChecked,
          "Expert list",
        );
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };

  const handleStageChange = async (stage, id) => {
    const response = await postData(`/experts/accept-reject/${id}`, {
      stage: stage,
    });

    if (response?.success) {
      // console.log("successsss");
      getDataAll();
    }
  };

  return (
    <>
      <div className="main-advancedashboard">
        <Header title={"Expert List"} link={"/expert-management/expert-list"} />
        <section className="AdvanceDashboard">
          <div className="row MainRowsec">
            <div className="col-lg-12">
              <div className="row MainRowsec">
                <section className="Tabels tab-radio tab-radio mt-3">
                  <div className="">
                    <div className="row">
                      <div className="d-flex">
                        <div className="add me-3"></div>

                        <div className="add me-1"></div>

                        {/* <div className="add">
                      <Button
                        variant="success"
                        className="btn btn-view"
                        onClick={HandleDownload}
                      >
                        {" "}
                        <FontAwesomeIcon
                          icon="fa-solid fa-download"
                          className="me-2"
                        />
                        Download
                      </Button>
                    </div> */}
                      </div>
                      <div className="row mt-4">
                        <div className="  col-lg-12 col-md-12 col-12">
                          <div className="d-flex">
                            <div className="show me-2">
                              <p className="show mt-1">Show</p>
                            </div>
                            <div className="number me-2">
                              <select
                                className="form-select form-select-sm"
                                aria-label=".form-select-sm example"
                                onChange={(e) => setperPage(e.target.value)}>
                                {option?.map((option) => (
                                  <option key={option} value={option}>
                                    {option}
                                  </option>
                                ))}
                              </select>
                            </div>
                            <div className="entries">
                              <p className="show mt-1">entries</p>
                            </div>
                          </div>
                        </div>
                        <div className="  col-lg-12  col-md-12 col-12">
                          <div className="row">
                            <div className="col-xxl-2 col-xl-3  col-lg-4  col-md-4 col-sm-6 col-12 mt-lg-3  mt-md-3 mt-3">
                              <div className="sowing me-2">
                                <p className="show mt-2">{`Showing ${Math.min(
                                  (currentPage - 1) * perPage + 1,
                                )} to ${Math.min(
                                  currentPage * perPage,
                                  data?.data?.totalEntries,
                                )} of ${data?.data?.totalEntries} entries`}</p>
                              </div>
                            </div>

                            <div className="col-xxl-2 col-xl-3  col-lg-4  col-md-4 col-sm-6 col-12 mt-lg-3  mt-md-3 mt-3">
                              <div className="num me-2">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Name"
                                  id=""
                                  value={search}
                                  onChange={(e) => {
                                    setSearch(e.target.value);
                                  }}
                                />
                              </div>
                            </div>
                            <div className="col-xxl-2 col-xl-3  col-lg-4  col-md-4 col-sm-6 col-12 mt-lg-3  mt-md-3 mt-3">
                              <div className="Search me-2">
                                <Button
                                  type="button"
                                  onClick={getDataAll}
                                  className="btn btn-search">
                                  <img
                                    src={search1}
                                    className="search"
                                    alt=""
                                  />
                                </Button>
                              </div>
                            </div>

                            <div className="col-xxl-2 col-xl-3  col-lg-4  col-md-4 col-sm-6 col-12 mt-lg-3  mt-md-3 mt-3">
                              <div className="Search-1">
                                <button
                                  type="button"
                                  onClick={() => {
                                    setSearch("");
                                    setReset(!reset);
                                  }}
                                  className="btn btn-reset">
                                  Reset
                                </button>
                              </div>{" "}
                            </div>

                            <div className="col-xxl-2 col-xl-3  col-lg-4  col-md-4 col-sm-6 col-12 mt-lg-3  mt-md-3 mt-3">
                              <button
                                className="btn btn-success greenSquareBtn"
                                onClick={HandleDownload}>
                                Download data in Excel
                                <FontAwesomeIcon
                                  icon="fa-solid fa-file-lines"
                                  className="ms-2"
                                />
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="border-line mt-3"></div>
                    <div className="row mt-3">
                      <div className="data table-responsive">
                        <Table striped bordered hover responsive center>
                          <thead>
                            <tr className="">
                              {visible.col0 && (
                                <th className="check round-check">
                                  <div className="form-check">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      value="selectAll"
                                      checked={
                                        allChecked.length ===
                                        selectAllChecked.length
                                      }
                                      onChange={handleChange}
                                      id="selectAll"
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="flexCheckChecked"></label>
                                  </div>
                                </th>
                              )}
                              {visible.col1 && <th className="sr">Sr. No.</th>}
                              {visible.col2 && (
                                <th
                                  className="tax-name"
                                  style={{ width: "400px" }}>
                                  Name
                                </th>
                              )}
                              {visible.col3 && (
                                <th
                                  className="tax-name"
                                  style={{ width: "400px" }}>
                                  Contact No
                                </th>
                              )}{" "}
                              {visible.col14 && (
                                <th
                                  className="tax-name"
                                  style={{ width: "400px" }}>
                                  City
                                </th>
                              )}{" "}
                              {/* {visible.col4 && (
                                <th
                                  className="tax-name"
                                  style={{ width: "400px" }}>
                                  Whatsapp No
                                </th>
                              )}{" "} */}
                              {visible.col5 && (
                                <th
                                  className="tax-name"
                                  style={{ width: "400px" }}>
                                  DOB
                                </th>
                              )}{" "}
                              {visible.col6 && (
                                <th
                                  className="tax-name"
                                  style={{ width: "400px" }}>
                                  Profession
                                </th>
                              )}{" "}
                              {visible.col7 && (
                                <th
                                  className="tax-name"
                                  style={{ width: "400px" }}>
                                  Experience
                                </th>
                              )}{" "}
                              {visible.col8 && (
                                <th
                                  className="tax-name"
                                  style={{ width: "400px" }}>
                                  Expert Category
                                </th>
                              )}{" "}
                              {visible.col8 && (
                                <th
                                  className="tax-name"
                                  style={{ width: "400px" }}>
                                  Expert Sub Category
                                </th>
                              )}{" "}
                              {visible.col11 && (
                                <th
                                  className="tax-name"
                                  style={{ width: "400px" }}>
                                  Expert Rating
                                </th>
                              )}
                              {visible.col9 && (
                                <th
                                  className="tax-name"
                                  style={{ width: "400px" }}>
                                  Status
                                </th>
                              )}
                              {visible.col13 && (
                                <th
                                  className="tax-name"
                                  style={{ width: "400px" }}>
                                  Top Expert Status
                                </th>
                              )}{" "}
                              {visible.col10 && (
                                <th
                                  className="tax-name"
                                  style={{ width: "400px" }}>
                                  Update Rating
                                </th>
                              )}
                              {visible.col11 && (
                                <th
                                  className="tax-name"
                                  style={{ width: "400px" }}>
                                  Status
                                </th>
                              )}{" "}
                              {visible.col12 && (
                                <th
                                  className="active"
                                  style={{ width: "400px" }}>
                                  Action
                                </th>
                              )}{" "}
                            </tr>
                          </thead>
                          <tbody>
                            {data?.data?.data?.length > 0 ? (
                              data.data.data.map((d, index) => {
                                const paginatedIndex =
                                  (onPageChange - 1) * perPage + index + 1;
                                return (
                                  <tr className="" key={index}>
                                    <td>
                                      <input
                                        type="checkbox"
                                        className="form-check-input"
                                        value={d?.id}
                                        name="perselected"
                                        checked={selectAllChecked.includes(
                                          d?.id,
                                        )}
                                        onChange={handleChange}
                                        id="flexCheckDefault"></input>
                                    </td>
                                    {visible.col1 && <td>{paginatedIndex}.</td>}{" "}
                                    {visible.col2 && <td>{d?.first_name}</td>}
                                    {visible.col3 && <td>{d?.contact_no}</td>}
                                    {visible.col14 && (
                                      <td>{d?.users_detail?.city?.name}</td>
                                    )}{" "}
                                    {/* {visible.col4 && (
                                      <td>{d?.users_detail?.watsapp_no}</td>
                                    )}{" "} */}
                                    {visible.col5 && (
                                      <td>{d?.users_detail?.dob}</td>
                                    )}{" "}
                                    {visible.col6 && (
                                      <td>{d?.users_detail?.profession}</td>
                                    )}{" "}
                                    {visible.col7 && (
                                      <td>{d?.users_detail?.experience}</td>
                                    )}
                                    {visible.col8 && (
                                      <td>
                                        {d?.users_detail?.expert_category?.name}
                                      </td>
                                    )}{" "}
                                    {visible.col8 && (
                                      <td>
                                        {
                                          d?.users_detail?.expert_sub_category
                                            ?.name
                                        }
                                      </td>
                                    )}{" "}
                                    {visible.col11 && (
                                      <td>{d?.rating || 0} Stars</td>
                                    )}
                                    {visible.col8 && (
                                      <td>
                                        {d?.stage == "Approved" ? (
                                          <span
                                            className={`badge ${
                                              d?.stage === "Approved"
                                                ? "bg-success"
                                                : "bg-danger"
                                            }`}>
                                            {d?.stage}
                                          </span>
                                        ) : d?.stage == "Rejected" ? (
                                          <div
                                            className={`badge ${
                                              d?.stage === "Approved"
                                                ? "bg-success"
                                                : "bg-danger"
                                            }`}>
                                            Rejected
                                          </div>
                                        ) : (
                                          <select
                                            className={`form-select ${
                                              d?.stage === "approved"
                                                ? "border-success text-success"
                                                : d?.stage === "rejected"
                                                  ? "border-danger text-danger"
                                                  : ""
                                            }`}
                                            value={d?.stage || ""}
                                            onChange={(e) =>
                                              handleStageChange(
                                                e.target.value,
                                                d?.id,
                                              )
                                            }>
                                            <option value="">Select</option>
                                            <option value="approved">
                                              Approved
                                            </option>
                                            <option value="rejected">
                                              Rejected
                                            </option>
                                          </select>
                                        )}
                                      </td>
                                    )}
                                    {visible.col13 && (
                                      <td>
                                        <div className="form-check form-switch">
                                          <input
                                            className="form-check-input"
                                            type="checkbox"
                                            role="switch"
                                            checked={d.top_status}
                                            onChange={(e) => {
                                              ChangeTopExpertStatus(
                                                d?.id,
                                                e.target.checked,
                                              );
                                            }}
                                            id={`topExpertSwitch${d?.id}`}
                                          />
                                          <label
                                            className="form-check-label"
                                            htmlFor={`topExpertSwitch${d?.id}`}>
                                            {d.top_status
                                              ? "Active"
                                              : "Inactive"}
                                          </label>
                                        </div>
                                      </td>
                                    )}
                                    {visible.col10 && (
                                      <td>
                                        <button
                                          type="button"
                                          className="give_rating_btn"
                                          onClick={() => {
                                            setUserID(d?.id);
                                            setModalShow(true);
                                          }}>
                                          Give Rating
                                        </button>
                                      </td>
                                    )}
                                    {visible.col11 && (
                                      <td>
                                        <div className="form-check form-switch">
                                          <input
                                            className="form-check-input"
                                            type="checkbox"
                                            role="switch"
                                            checked={d?.status}
                                            // disabled={!isAllow?.includes(11)}
                                            onChange={(e) => {
                                              ChangeStatus(
                                                d?.id,
                                                e.target.checked,
                                              );
                                            }}
                                            id={`flexSwitchCheckDefault${d?.id}`}
                                          />
                                          <label
                                            className="form-check-label"
                                            htmlFor={`flexSwitchCheckDefault${d?.id}`}>
                                            {d?.status ? "Active" : "Inactive"}
                                          </label>
                                        </div>
                                      </td>
                                    )}
                                    {visible.col12 && (
                                      <td>
                                        <div className="d-flex">
                                          <DeletButton
                                            showDeleteRecord={showDeleteRecord}
                                            id={d?.id}
                                            name={d?.first_name}
                                          />
                                        </div>
                                      </td>
                                    )}
                                  </tr>
                                );
                              })
                            ) : (
                              <tr>
                                <td colSpan="10" className="text-center">
                                  Data not available
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </Table>{" "}
                        <Pagination_Holder
                          onPageChange={currentPage}
                          totalPages={totalPages}
                          handlePageChange={handlePageChange}
                        />
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </section>
      </div>

      {/* <!-- Modal Delete --> */}
      <div div className="upload-modal">
        <div
          className={`modal fade ${showDeleteModal ? "show" : ""}`}
          style={{ display: showDeleteModal ? "block" : "none" }}
          id="exampleModaldel"
          tabIndex="-1"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true">
          <div className="modal-dialog  modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body">
                <h1 className="add-success text-center  mt-2">
                  Are you sure ?
                </h1>
                <p>
                  Do You Really Want to Delete These Record?
                  <br /> This Process CanNot Be Undone{" "}
                </p>
                <div className="button-holder text-center mt-2">
                  <button
                    className="btn btn-yes me-2"
                    onClick={handleDeleteRecord}>
                    Yes
                  </button>
                  <button className="btn btn-no" onClick={handleDeleteCancel}>
                    No
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Toaster position="top-right" />

      <Rating_Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        id={userId}
        getDataAll={getDataAll}
      />
    </>
  );
};

export default Tables;
